import React from "react";
import {
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
  Platform,
  TouchableNativeFeedback,
  Image,
  Dimensions,
} from "react-native";
import Colors from "../constants/Colors";
import DefaultTextLight from "./text/DefaultTextLight";
import DefaultText from "./text/DefaultText";

const GridTileTwo = (props) => {
  let TouchableCmp = TouchableOpacity;
  if (Platform.OS === "android" && Platform.Version >= 21) {
    TouchableCmp = TouchableNativeFeedback;
  }
  let thumbnailImg = props.imageUrl;
  if (props.imageUrl.endsWith("mp4") || props.imageUrl.endsWith("svg")) {
    thumbnailImg = props.collectionImageUrl;
  }
  if (props.empty === true) {
    return <View style={[styles.gridItem, styles.itemInvisible]} />;
  }
  return (
    <View style={styles.gridItem}>
      <TouchableCmp
        style={{ flex: 1, backgroundColor: "black" }}
        onPress={props.onSelect}
      >
        <View style={styles.imgContainer}>
          <Image style={styles.image} source={{ uri: thumbnailImg }} />
        </View>
        <DefaultText style={styles.title} numberOfLines={2}>
          {props.title}
        </DefaultText>

        <DefaultTextLight style={styles.artist} numberOfLines={1}>
          {props.artist}
        </DefaultTextLight>
      </TouchableCmp>
    </View>
  );
};

const numColumns = 2;
const maxWidth = 500;
let { height, width } = Dimensions.get("window");
width = width > maxWidth ? maxWidth : width;
const gridMargin = 10;
const gridWidth = Math.floor((width - gridMargin * numColumns) / numColumns);

const styles = StyleSheet.create({
  gridItem: {
    flex: 1,
    margin: gridMargin,
    height: Platform.OS === "web" ? gridWidth + 32 : null,
    width: gridWidth,
    overflow:
      Platform.OS === "android" && Platform.Version >= 21
        ? "hidden"
        : "visible",
  },
  imgContainer: {
    flex: 1,
    width: gridWidth,
    height: gridWidth,
  },
  title: {
    paddingTop: 12,
    textAlign: "left",
  },
  artist: {
    paddingTop: 3,
    textAlign: "left",
  },
  image: {
    width: "100%",
    height: "100%",
    aspectRatio: 1,
  },
  itemInvisible: {
    backgroundColor: "transparent",
  },
});

export default GridTileTwo;
